import React, { useEffect, useState } from 'react';
import {
  Typography,
  Divider,
  Box,
  Grid,
} from '@material-ui/core';
import { Button, TextField, CurrencyField } from '@roc/ui';
import { BackgroundItemStore } from '../stores/backgroundItemStore';

interface NewCollectionAccountItemFormProps {
  store: BackgroundItemStore;
  handleClose: () => void;
  subtitle: string;
  index?: number;
  record?: string;
}

const NewCollectionAccountItemForm = ({ store, handleClose, subtitle, index, record }: NewCollectionAccountItemFormProps) => {
  const [creditComment, setCreditComment] = useState('');
  const [itemName, setItemName] = useState('');
  const [balanceAmount, setUnpaidBalance] = useState(0);
  const [highCreditAmount, setHighCredit] = useState(0);
  const [accountType, setAccountType] = useState('');
  const [pastDue, setPastDue] = useState(0);

  useEffect(() => {
    if (index >= 0) {
      if (record) {
        setItemName(store.backgroundSectionDetails.backgroundSection[record][index].item);
        setCreditComment(store.backgroundSectionDetails.backgroundSection[record][index].creditComment);
        setUnpaidBalance(store.backgroundSectionDetails.backgroundSection[record][index].balanceAmount);
        setHighCredit(store.backgroundSectionDetails.backgroundSection[record][index].highCreditAmount);
        setAccountType(store.backgroundSectionDetails.backgroundSection[record][index].accountType);
        setPastDue(store.backgroundSectionDetails.backgroundSection[record][index].pastDue);
      }
    }
  }, [])

  const handleSubmit = (e: React.FormEvent, record?: string) => {
    e.preventDefault();

    if (index >= 0) {
      if (record) {
        store.editCARecordItem(itemName, creditComment, balanceAmount, highCreditAmount, pastDue, accountType, record, index);
      }
    }
    else {
      if (record) {
        store.addCARecordItem(itemName, creditComment, balanceAmount, highCreditAmount, pastDue, accountType, record)
      }
    }
    handleClose();
  };

  const handleCancel = (e: React.FormEvent) => {
    handleClose();
  };

  return (
    <form onSubmit={(e) => { handleSubmit(e, record) }}>
      <Typography variant='h5'>Review Item</Typography>
      <Divider />
      <Typography variant='h6'>{subtitle}</Typography>
      <TextField
        type="text"
        variant="outlined"
        label="Full Name"
        value={itemName}
        onChange={(e) => setItemName(e.target.value)}
        fullWidth
        margin="normal"
        required
        testId="shareUrl"
      />
      <TextField
        type="text"
        variant="outlined"
        label="Credit Comment"
        value={creditComment}
        onChange={(e) => setCreditComment(e.target.value)}
        fullWidth
        margin="normal"
        required
        testId="shareUrl"
      />
      <CurrencyField
        variant="outlined"
        label="Unpaid Balance *"
        value={balanceAmount}
        onChange={(name, value) => setUnpaidBalance(Number(value))}
        fullWidth
        margin="normal"
        groupSeparator=","
        allowNegative={false}
        testId="shareUrl"
      />
      <CurrencyField
        variant="outlined"
        label="High Credit *"
        value={highCreditAmount}
        onChange={(name, value) => setHighCredit(Number(value))}
        fullWidth
        margin="normal"
        groupSeparator=","
        allowNegative={false}
        testId="shareUrl"
      />
      <CurrencyField
        variant="outlined"
        label="Past Due *"
        value={pastDue}
        onChange={(name, value) => setPastDue(Number(value))}
        fullWidth
        margin="normal"
        groupSeparator=","
        allowNegative={false}
        testId="shareUrl"
      />
      <TextField
        type="string"
        variant="outlined"
        label="Account Type"
        value={accountType}
        onChange={(e) => setAccountType(e.target.value)}
        fullWidth
        margin="normal"
        required
        testId="shareUrl"
      />
      <Box marginTop={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Button onClick={handleCancel} variant="outlined" color="primary" testId="cancel" fullWidth>
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button type="submit" variant="contained" color="primary" testId="save" fullWidth>
              Save
            </Button>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export default NewCollectionAccountItemForm;